import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import ContactUsImg from "../assets/images/contactUs.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss"
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
const ContactUsPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground insideText={"Contact Us"} imgPath={ContactUsImg} />
      <GetInTouch />
      {/* <TestimonialsTravala/> */}
    </div>
  );
};

export default ContactUsPage;
